export var ETableActionType;
(function (ETableActionType) {
    ETableActionType["DrillDown"] = "drillDown";
    ETableActionType["TradeContribution"] = "tradeContribution";
    ETableActionType["OpenTrade"] = "openTrade";
    ETableActionType["RowActions"] = "rowActions";
})(ETableActionType || (ETableActionType = {}));
